const enTranslation = {
  "loading": "Loading...",
  "chatbot_title": "Welcome to your new chat!",
  "chatbot_description": "Ask questions about your social media account",
  "new_chat": "New Chat",
  "new_chat_title": "New Chat Title",
  "search_chats": "Search chats...",
  "send_message_placeholder": "Type your message...",
  "loading_assistant": "Loading Your Assistant...",
  "assistant_thinking": "Lema is thinking...",
  "drafting_answer": "Drafting the answer...",
  "notify_when_done": "Want Lema to notify you when it's done?",
  "notify_me": "Notify me",
  "notification_set": "We'll notify you when it's ready",
  "send_instruction": "Press Enter to send, Shift+Enter for new line",
  "select_chat_or_new": "Select a chat or create a new one",
  "attach_files": "Attach files",
  "assistant": "Assistant",
  "you": "You",
  "sources": "Sources",
  "citation": "Citation",
  "items": "items",
  "error_initializing_chatbot": "Error initializing chatbot",
  "failed_fetch_history": "Failed to fetch message history",
  "error_creating_chat": "Error creating new chat",
  "failed_create_new_chat": "Failed to create new chat",
  "file_upload_error": "File upload error",
  "error_uploading_file": "Error uploading file",
  "conversation_not_found_new_one": "Conversation not found, creating a new one",
  "error_creating_conversation": "Error creating new conversation",
  "error_sending_message": "Error sending message",
  "error_regenerating_message": "Error regenerating message",
  "conversation_error_try_again": "Sorry, there was an error with the conversation. Please try again.",
  "new_conversation_error_try_again": "Sorry, there was an error creating a new conversation. Please try again.",
  "processing_request_error_try_again": "Sorry, there was an error processing your request. Please try again.",
  "regenerating_message_error_try_again": "Sorry, there was an error regenerating the message. Please try again.",
  "request_timed_out_try_again": "Request timed out. Please try again.",
  "generic_error": "Error",
  "generic_processing_error_try_again": "Sorry, there was an error processing your request.",
  "stop_generation": "Stop generation",
  "stop": "Stop",
  "start_conversation": "Start conversation",
  "cancel": "Cancel",
  "save_edit": "Save",
  "download_file": "Download file",
  "no_chats_found": "No chats found matching your search.",
  "no_chats_yet": "No chats yet. Start a new one!",
  "rename_chat": "Rename chat",
  "confirm_delete_chat": "Are you sure you want to delete the chat \"{{title}}\"?",
  "search": {
    "title": "Brand Search",
    "placeholder": "Search for brands...",
    "search_button": "Search",
    "loading": "Searching for brands...",
    "empty_state": "Enter a search term to find brand collaboration opportunities",
    "connect_title": "Connect Your Account",
    "connect_description": "Connect your social media so Lema can find you collaboration partners",
    "connect_button": "Go to Account Settings",
    "loading_search": "Loading search...",
    "visit_website": "Visit Website",
    "score": "Score",
    "description": "Search for brand recommendations and monitor for new matches",
    "error_label": "Error",
    "recommended_brands": "Recommended Brands",
    "brands": "Brands",
    "relevance": "Relevance",
    "lead_score": "Lead Score",
    "profile": "Profile",
    "collapse_tooltip": "Click to collapse",
    "expand_tooltip": "Click to expand",
    "results_range": "{{start}}-{{end}} of {{total}} results",
    "zero_results": "0 results",
    "unexpected_response": "Received unexpected response format from server",
    "auth_required": "Authentication required. Please log in again.",
    "connect_account_before_search": "Please connect a social media account before searching. Go to your account settings to connect an account.",
    "search_failed": "Failed to perform search",
    "unexpected_error": "An unexpected error occurred",
    "recommendations_tab": "Recommendations",
    "history_tab": "History",
    "affiliate_recommendations": "Affiliate Recommendations",
    "results": "results",
    "no_affiliate_recommendations": "No affiliate recommendations found",
    "affiliate_recommendations.brands": "Brands",
    "affiliate_recommendations.description": "Description",
    "affiliate_recommendations.recommendation_score": "Score",
    "affiliate_recommendations.commission_rate": "Commission",
    "affiliate_recommendations.audience": "Audience",
    "affiliate_recommendations.apply": "Apply",
    "affiliate_recommendations.commission": "Commission"
  },
  "delete_chat": "Delete chat",
  "remove_file": "Remove file",
  "uploading_files": "Uploading files...",
  "send_message": "Send message",
  "type_message_or_attach": "Type a message or attach a file",
  "send_instruction_short": "Enter to send, Shift+Enter for new line",
  "like_message": "Like message",
  "remove_like": "Remove like",
  "dislike_message": "Dislike message",
  "remove_dislike": "Remove dislike",
  "copy_message": "Copy message",
  "reply_to_message": "Reply to message",
  "edit_message": "Edit message",
  "regenerate_response": "Regenerate response",
  "drop_files_here": "Drop files here",
  "chats_title": "Chats",
  "jump_to_original": "Jump to original",
  "replying_to": "Replying to",
  "error_file_too_large": "Files exceeding {{maxSize}} limit: {{files}}",
  "error_compress_first": "Please compress them first or try smaller files.",
  "agent": {
    "tools": {
      "find_brand_leads": "Find brand leads",
      "query_database": "Getting Data From Database",
      "searching_web": "Searching the Web",
      "creating_post": "Creating Post",
      "lead_gen_v9": "Looking For Brands",
      "google_instagram_search": "Searching the Web",
      "create_post": "Creating Post",
      "query_supabase_v2": "Fetching Data",
      "scrape_tiktok_profile": "Getting TikTok Profile",
      "scrape_instagram_profile": "Getting Instagram Profile",
      "link_captioner": "Understanding the Link",
      "fetching_audience": "Fetching Audience Data",
      "deep_statistics_agent": "Analyzing Statistics",
      "plan": "Plan",
      "tool_call": "Tool Call",
      "working": "Working"
    }
  },
  "indexing_messages": [
    "Fetching your data...",
    "Understanding your profile...",
    "Indexing your text...",
    "Committing to memory...",
    "Downloading your pictures...",
    "Downloading your videos...",
    "Compressing your pictures...",
    "Compressing your videos...",
    "Creating embeddings for your pictures...",
    "Creating embeddings for your videos...",
    "Committing to memory...",
    "Cleaning your data...",
  ],
  "connect": {
    "title": "Connect Your Account",
    "button": "Go to Account Settings",
    "chat_description": "Connect your social media to unlock personalized content insights and chat with Lema",
    "portfolio_description": "Connect your social media to generate your portfolio."
  },
  "error": {
    "rate_limit_title": "Rate Limit Reached",
    "rate_limit_message": "Try again in 1 minute or upgrade to a paid plan to experience less disruption",
    "rate_limit_monthly_exceeded": "Your monthly message limit has been exceeded. Please upgrade your tier to continue.",
    "rate_limit_wait_and_retry": "Too many requests. Please wait and retry",
    "dify_agent_title": "Processing Error",
    "dify_agent_message": "Lema encountered an error. Regenerate or send a different message",
    "content_policy_title": "Lema encountered an error",
    "content_policy_message": "Regenerate or send a different message",
    "could_not_recover_response": "Lema is still crafting your response. Please refresh in a few minutes.",
    "chat_rate_limit_exceeded": "Rate limit exceeded. Please upgrade your plan.",
    "chat_critical_error": "A critical error occurred.",
    "chat_regenerate_failed": "Error regenerating response.",
    "chat_resend_failed": "Error resending message.",
    "chat_stream_error": "Stream Error",
    "chat_read_stream_error": "Error reading response stream.",
    "chat_timeout": "Request timed out. Please try again.",
    "chat_no_response_body": "No response body received",
    "chat_stop_streaming_failed": "Failed to stop streaming",
    "chat_stream_error_title": "Connection Lost",
    "chat_stream_error_message": "The connection was interrupted. This might be a temporary network issue. Please try again.",
    "chat_init_chatbot_failed": "Error initializing chatbot",
    "chat_fetch_history_failed": "Failed to fetch message history",
    "chat_create_chat_failed": "Error creating new chat",
    "chat_create_conversation_failed": "Error creating new conversation",
    "chat_send_message_failed": "Error sending message",
    "chat_conversation_error": "Sorry, there was an error with the conversation. Please try again.",
    "chat_new_conversation_error": "Sorry, there was an error creating a new conversation. Please try again.",
    "chat_processing_error": "Sorry, there was an error processing your request. Please try again.",
    "chat_generic_error": "Sorry, there was an error processing your request.",
    "chat_recover_failed": "Could not recover response from server. Please create new chat and send a new message",
    "auth_verification_failed": "Verification failed. Please try again.",
    "auth_google_signin_failed": "Failed to initiate Google sign-in. Please try again.",
    "auth_google_signup_failed": "Failed to initiate Google sign-up. Please try again.",
    "auth_password_mismatch": "Passwords do not match",
    "auth_session_expired": "Your session has expired. Please sign in again.",
    "auth_sign_out_failed": "Failed to sign out",
    "auth_update_state_failed": "Failed to update authentication state",
    "auth_refresh_session_failed": "Failed to refresh session",
    "auth_init_auth_failed": "Failed to initialize authentication",
    "file_upload_failed": "Error uploading file",
    "file_too_large": "File size exceeds the maximum limit",
    "file_compress_first": "Please compress files first or try smaller files.",
    "file_invalid_format": "Invalid file format",
    "file_caption_failed": "Captioning failed",
    "file_caption_timeout": "Captioning request timed out.",
    "file_caption_invalid_response": "Captioning request succeeded but response was not valid JSON.",
    "file_url_upload_failed": "URL upload failed",
    "social_load_instagram_failed": "Failed to load Instagram data",
    "social_load_tiktok_failed": "Failed to load TikTok data",
    "social_load_youtube_failed": "Failed to load YouTube data",
    "social_disconnect_failed": "Failed to disconnect account",
    "social_connection_failed": "Connection failed",
    "social_token_exchange_failed": "Token exchange failed",
    "social_save_connection_failed": "An error occurred while saving the connection.",
    "social_fetch_accounts_failed": "Failed to fetch accounts",
    "social_select_account_failed": "Failed to select account",
    "social_indexing_failed": "Indexing failed",
    "social_indexing_timeout": "Indexing timed out while waiting for completion",
    "social_fetch_timeout": "Social fetch timed out while waiting for completion",
    "portfolio_enter_username": "Please enter a username",
    "portfolio_user_not_found": "Username not found in our system.",
    "portfolio_connect_first": "Please connect the account first in",
    "portfolio_generation_failed": "Failed to generate portfolio",
    "portfolio_generic_error": "An error occurred while generating the portfolio",
    "portfolio_not_found_title": "Portfolio Not Found",
    "search_unexpected_response": "Received unexpected response format from server",
    "search_auth_required": "Authentication required. Please log in again.",
    "search_connect_account_first": "Please connect a social media account before searching. Go to your account settings to connect an account.",
    "search_failed": "Failed to perform search",
    "search_unexpected_error": "An unexpected error occurred",
    "verification_rate_limit": "Please wait before trying again",
    "verification_send_failed": "Failed to send verification email. Please try again.",
    "subscription_already_active_title": "Active Subscription Found",
    "subscription_already_active_message": "You already have an active subscription. Please manage your subscription from your account page.",
    "general_unexpected_error": "We apologize for the inconvenience. An unexpected error has occurred.",
    "general_network_error": "Network error. Please check your connection.",
    "general_timeout": "Request timed out. Please try again.",
    "general_unknown_error": "Unknown error occurred",
    "general_fetch_failed": "Failed to fetch data",
    "general_save_failed": "Failed to save changes",
    "general_load_failed": "Unable to load data right now."
  },
  "success": {
    "auth_sign_in_success": "Successfully signed in",
    "auth_sign_out_success": "Successfully signed out",
    "auth_verification_sent": "Verification email sent",
    "social_connected": "Account connected successfully",
    "social_disconnected": "Account disconnected successfully",
    "social_indexing_complete": "Indexing completed successfully",
    "portfolio_generated": "Portfolio generated successfully",
    "file_uploaded": "File uploaded successfully",
    "chat_message_sent": "Message sent successfully"
  },
  "warning": {
    "file_size_warning": "Large file detected. Consider compressing before upload.",
    "file_format_warning": "This file format may not be supported.",
    "social_disconnection_warning": "Disconnecting will remove access to your data.",
    "social_indexing_in_progress": "Indexing is in progress. Please do not close this page.",
    "chat_long_response": "Generating a detailed response. This may take a moment.",
    "chat_incomplete_response_title": "Stream Interrupted",
    "chat_incomplete_response": "Response incomplete. Refresh for full message."
  },
  "common": {
    "close": "Close",
    "collapse_sidebar": "Collapse sidebar",
    "close_sidebar": "Close sidebar",
    "scroll_to_view": "Scroll to view",
    "click_days_for_details": "Click on days for content details",
    "explore_idea_deeper": "Explore Idea Deeper",
    "swipe_to_scroll": "Swipe to scroll",
    "click_arrows_to_scroll": "Click arrows to scroll"
  },
  "rate_limit_exceeded": "Your monthly message limit has been exceeded. Please upgrade your tier to continue.",
  "nav": {
    "pricing": "Pricing",
    "chat": "Chat",
    "search": "Search",
    "portfolio": "Portfolio",
    "account": "Account",
    "signOut": "Sign Out",
    "signIn": "Sign In",
    "getStarted": "Start for Free",
    "overview": "Overview",
    "platforms": "Platforms",
    "features": "Features",
    "about": "About",
    "demo": "Demo",
    "openMainMenu": "Open main menu",
    "expandChatHistory": "Expand chat history",
    "dataStatus": {
      "connected": "Data is connected",
      "needsUpdate": "Data needs to be updated",
      "loading": "Data is loading",
      "notConnected": "Data is not connected",
      "checking": "Checking data status...",
      "labelNotConnected": "Data not connected"
    }
  },
  "portfolio": {
    "title": "Portfolio Generator",
    "description": "Create a professional portfolio for your social media content",
    "instagram_username_label": "Username",
    "username_placeholder": "username",
    "error_enter_username": "Please enter a username",
    "error_user_not_found": "Username not found in our system.",
    "error_connect_first": "Please connect the account first in",
    "error_generation_failed": "Failed to generate portfolio",
    "error_generic": "An error occurred while generating the portfolio",
    "generating": "Generating Portfolio...",
    "generate_button": "Generate New Portfolio",
    "publicly_accessible_at": "The generated portfolio will be publicly accessible at",
    "existing_portfolio_title": "Existing Portfolio",
    "visit_button": "Visit",
    "preview_title": "Portfolio Preview",
    "connect_title": "Connect Your Account",
    "connect_description": "Connect your social media to unlock personalized portfolio creation and showcase your content",
    "connect_button": "Go to Account Settings"
  },
  "portfolioDisplay": {
    "loading": "Loading portfolio...",
    "not_found_title": "Portfolio Not Found",
    "generate_new": "Generate New Portfolio",
    "audience": "Audience",
    "niche_performance": "Niche Performance",
    "metrics": {
      "followers": "followers",
      "engagement": "engagement",
      "average_views": "average views",
      "peak_views": "peak views",
      "average_views_label": "AVERAGE VIEWS",
      "engagement_label": "ENGAGEMENT",
      "per_post_in_niche": "Per post in Niche"
    },
    "contact_me": "Contact Me",
    "no_contact_info": "No contact information available"
  },
  "landing": {
    "placeholder_profile_link": "Link to Instagram / TikTok profile...",
    "placeholder_brands": "Arts and crafts brands...",
    "action_button_evaluate": "(Evaluate my profile)",
    "action_button_find_brand": "(Find brand sponsorship)",
    "action_button_engagement": "(Calculate engagement rate)",
    "action_text_evaluate": "Evaluate My Profile",
    "action_text_find_brand": "Find Brand Sponsorship",
    "action_text_engagement": "Calculate Engagement Rate",
    "action_text_create_script": "Create Script",
    "prompt_create_content_calendar": "create 10 days content calendar for",
    "placeholder_evaluate": "Type your Instagram / TikTok / YouTube link",
    "placeholder_find_brand": "Type the brand that you want",
    "placeholder_engagement": "Type your Instagram / TikTok / YouTube link",
    "placeholder_create_script": "Type your Instagram / TikTok / YouTube link",
    "press_enter_to_ask_ai": "Press Enter to ask Lema",
    "hero_title": "Lema: AI for Creators",
    "hero_subtitle_prefix": "Creator Companion that",
    "hero_subtitle_cocreate": "co-creates with you, anytime",
    "hero_subtitle_analytics": "decodes your analytics",
    "hero_subtitle_available": "understand all of your content",
    "overview_title": "Your AI Companion",
    "overview_description": "An AI that has watched all your content, is always available to co-create, and interprets your data so you don't have to.",
    "continuation_text": "By continuing, you agree to our",
    "terms_of_service": "terms of service",
    "privacy_policy": "privacy policy",
    "features_title": "What Lema Does For You",
    "features_subtitle": "Your AI companion, built for creators",
    "feature_cocreate_title": "Co-Create Together",
    "feature_cocreate_description": "Brainstorm ideas, write scripts, and refine your creative vision with an AI that truly knows your work.",
    "animation_cocreate_user": "What should my next cooking video be about?",
    "animation_cocreate_lema_before": "Based on your top-performing reels, ",
    "animation_cocreate_lema_highlight": "DIY recipes with clear step-by-step instructions",
    "animation_cocreate_lema_after": " get +90% more likes.",
    "animation_cocreate_tip1": "Try a homemade nastar tutorial",
    "animation_cocreate_tip2": "Add a cost breakdown hook",
    "feature_understand_data_title": "Understand Your Data",
    "feature_understand_data_description": "Figure out what works, what doesn't, and why — so you can make smarter content decisions.",
    "feature_always_there_title": "Be There For Your Journey",
    "feature_always_there_description": "Need a second opinion? Editing feeling rough? Lema is always available when you need it.",
    "platforms_title": "We Serve Creators on",
    "platforms_subtitle": "Instagram, TikTok, and YouTube",
    "pricing_title": "Pricing",
    "pricing_subtitle": "Choose the plan that's right for you.",
    "billing_monthly": "Monthly",
    "billing_yearly": "Yearly",
    "pricing_plans": {
      "free": {
        "title": "Free",
        "button_text": "Get Started",
        "price_description": "per month"
      },
      "pro": {
        "title": "Pro",
        "button_text": "Select Plan",
        "price_description": "per month",
        "monthly_price": "$20",
        "yearly_price": "$16",
        "yearly_helper": "(billed monthly) at {{usd}} per year"
      },
      "pro_plus": {
        "title": "Pro+",
        "button_text": "Select Plan",
        "price_description": "per month",
        "monthly_price": "$60",
        "yearly_price": "$48",
        "yearly_helper": "(billed monthly) at {{usd}} per year"
      }
    },
    "pricing_features": {
      "credits_free": "30 credits you can spend for",
      "credits_pro": "100 credits you can spend for",
      "credits_pro_plus": "500 credits you can spend for",
      "brainstorm_growth": "Brainstorm how to grow your profile",
      "analyze_performance": "Analyze why contents perform well / not",
      "generate_content_ideas": "Generate content ideas",
      "search_brands_collab": "Ask for any advice you want!"
    },
    "pricing_recommended": "Recommended",
    "pricing_redirecting": "Redirecting...",
    "about_title": "About Us",
    "about_team_title": "Our Team",
    "about_team_body": "We are a team of two founders (ex-Meta content & ML team, Oxford + Huawei Research).",
    "about_name_origin_title": "Name Origin",
    "about_name_origin_body": "Why the name Lema? In mathematics a \"lemma\" is a small theorem which acts as a tool used to prove a larger theorem. We believe that people should be able to make a living off of what they're passionate about and Lema is our tool to prove that.",
    "about_impact_title": "Impact",
    "stat_founded": "Founded",
    "stat_creators_served": "Creators Served",
    "stat_brand_deals_closed": "Brand Deals Closed",
    "about_support_body": "We love content creation and would like to support your content creator journey",
    "about_talk_button": "Talk directly with us",
    "try_it_now": "Try it now",
    "animation": {
      "views_up": "Views up — strong hook",
      "shares_dip": "Shares dip — divisive angle",
      "saves_spike": "Saves spike — actionable tips",
      "reach_drops": "Reach drops — weak opener",
      "comments_up": "Comments up — relatable moment",
      "likes_dip": "Likes dip — mixed message"
    },
    "vs_title": "Why Lema, Not ChatGPT?",
    "vs_title_prefix": "Why Lema, Not",
    "vs_subtitle": "Most AI wasn't built for creators. Lema is.",
    "vs_creators_title": "Trained on Top Creators",
    "vs_creators_description": "Lema studies what high-engagement creators do — turning real creator data into patterns, not generic web content.",
    "vs_video_title": "Actually Watches Videos",
    "vs_video_description": "Paste a link and Lema genuinely watches it. Other AI tools often can't — they just make things up.",
    "vs_personal_title": "Knows Your Account",
    "vs_personal_description": "Lema advises you based on what you've actually posted. No hollow tips like \"post more\" or \"follow trends\".",
    "vs_animation_patterns_header": "Top creator signals",
    "vs_patterns_industry_cooking": "Top cooking creators",
    "vs_pattern_cooking_1": "Science / lab demonstrations",
    "vs_pattern_cooking_2": "Clear step-by-step tutorials",
    "vs_pattern_cooking_3": "Recipe + DIY content",
    "vs_patterns_industry_beauty": "Top beauty creators",
    "vs_pattern_beauty_1": "Before & after transformations",
    "vs_pattern_beauty_2": "Get-ready-with-me routines",
    "vs_pattern_beauty_3": "Drugstore dupe reviews",
    "vs_patterns_industry_travel": "Top travel creators",
    "vs_pattern_travel_1": "Hidden gem destination reveals",
    "vs_pattern_travel_2": "Budget travel hacks",
    "vs_pattern_travel_3": "Day-in-the-life vlogs",
    "vs_patterns_industry_fitness": "Top fitness creators",
    "vs_pattern_fitness_1": "Form correction breakdowns",
    "vs_pattern_fitness_2": "30-day challenge series",
    "vs_pattern_fitness_3": "Meal prep + workout combos",
    "vs_patterns_industry_lifestyle": "Top lifestyle creators",
    "vs_pattern_lifestyle_1": "Morning routine POVs",
    "vs_pattern_lifestyle_2": "Room makeover reveals",
    "vs_pattern_lifestyle_3": "Productivity walkthroughs",
    "vs_animation_patterns_footer": "Lema learns from these patterns",
    "vs_animation_video_watching": "Watching...",
    "vs_animation_video_done": "✓ Analyzed",
    "vs_animation_video_tag_1": "Tutorial format",
    "vs_animation_video_tag_2": "Strong hook at 0:03",
    "vs_animation_video_tag_3": "Clear call-to-action",
    "vs_animation_personal_label": "For you",
    "vs_animation_personal_followers": "{{count}} followers",
    "vs_animation_personal_insight_label": "Insight",
    "vs_animation_personal_insight_text": "Your videos under 1 minute with 70%+ speech have higher retention and average watch time.",
    "vs_animation_personal_insight_text_2": "Step-by-step tutorials drive 3× more saves than your lifestyle content.",
    "vs_animation_personal_insight_text_3": "Content with on-screen text captions earns 45% more replays from first-time viewers.",
    "vs_animation_personal_scanning": "Analyzing...",
    "vs_animation_personal_analyzed": "Analyzed"
  },
  "authVerifyEmail": {
    "titleDefault": "Check your email",
    "titleSent": "Email sent!",
    "descriptionDefault": "We've sent a confirmation email to {{email}}",
    "descriptionSent": "We've sent another confirmation email to {{email}}",
    "noEmailTitle": "Verification Required",
    "noEmailDescription": "Please sign up to receive a verification email.",
    "backToSignUp": "Back to Sign Up",
    "bodyIntro": "Please click the link in the email to verify your account and complete your registration.",
    "bodyExpiry": "The link will expire in 24 hours.",
    "notReceived": "Don't see the email? Check your spam folder or",
    "resendCta": "Resend verification email",
    "sending": "Sending...",
    "rateLimitError": "Please wait before trying again",
    "genericError": "Failed to send verification email. Please try again.",
    "rateLimitCountdown": "Please wait {{seconds}} seconds before trying again",
    "continueToSignIn": "Continue to Sign In"
  },
  "account": {
    "title": "Account Settings",
    "no_accounts_found": "No Instagram Accounts Found",
    "no_threads_accounts_found": "No Threads Accounts Found",
    "connecting": "Connecting...",
    "connect_with_facebook": "Connect Instagram with Facebook Login",
    "connect_with_instagram": "Connect with Instagram",
    "connect_with_threads": "Connect with Threads",
    "no_tiktok_accounts_found": "No TikTok Accounts Found",
    "connect_with_tiktok": "Connect with TikTok",
    "connect_with_tiktok_business": "Connect your TikTok Business Account",
    "no_youtube_accounts_found": "No YouTube Accounts Found",
    "connect_with_youtube": "Connect with YouTube",
    "go_back_to_account": "← Go Back to Account Page",
    "select_account_title": "Select Your Instagram Account",
    "select_account_description": "Choose which Instagram Professional account you'd like to use with Lema",
    "no_professional_accounts_found": "No Instagram Professional Accounts Found",
    "no_professional_accounts_description": "No Instagram Professional Accounts were found connected to your Facebook account.",
    "retrying": "Retrying...",
    "try_again": "Try Again",
    "processing": "Processing...",
    "connect_social_accounts": "Connect Your Social Media Accounts",
    "usage": {
      "title": "Usage Summary",
      "usage_since": "Usage since {{date}}",
      "loading": "Loading usage data…",
      "plan_label": "Plan",
      "unused": "Unused",
      "of_limit_used": "/{{limit}} used",
      "available": "{{limit}} available",
      "left": "{{count}} left",
      "unlimited": "Unlimited",
      "error_unable_to_load": "Unable to load usage data right now.",
      "retry": "Retry",
      "credits_title": "Usage Credits",
      "credits_description": "Monthly allowance for the {{tier}} plan.",
      "need_more": {
        "title": "Need more?",
        "description": "Pro gives you 100 credits per month and Pro+ gives you 500 credits per month.",
        "upgrade_pro": "Upgrade to Pro",
        "upgrade_pro_plus": "Upgrade to Pro+",
        "cancel_subscription": "Cancel Subscription",
        "contact_for_credits": "Contact Us for More Credits"
      },
      "cancel_dialog": {
        "title": "Cancel Subscription",
        "message": "Your account will be downgraded to Free and there's no refund. Continue?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "canceling": "Canceling...",
        "success": "Subscription canceled successfully",
        "error": "Failed to cancel subscription"
      },
      "upgrade_dialog": {
        "title": "Confirm Subscription Upgrade",
        "message": "Upgrade from {{currentPlan}} (${{currentPrice}}/month) to {{newPlan}} (${{newPrice}}/month) with {{newCredits}} credits per month. You'll be charged a prorated amount today.",
        "confirm": "Confirm Upgrade",
        "cancel": "Cancel",
        "upgrading": "Upgrading..."
      },
      "upgrade_success": "Subscription upgraded successfully!",
      "plan_names": {
        "free": "Free",
        "pro": "Pro",
        "pro_plus": "Pro+"
      }
    },
    "password_panel_title": "Change / Set Password",
    "password_panel_description": "for your email & password login",
    "password_change_title": "Change password",
    "password_set_title": "Set password",
    "password_set_description": "to enable email & password login",
    "update_password_button": "Update Password",
    "set_password_button": "Set Password",
    "password_updating": "Updating...",
    "password_change_cta": "Change password",
    "password_set_cta": "Set password"
  },
  "auth": {
    "signup_title": "Start for Free",
    "signup_subtitle": "You don't have to connect any social media account 😉",
    "field_required": "Please fill out this field.",
    "email_label": "Email",
    "password_label": "Password",
    "repeat_password_label": "Repeat Password",
    "email_placeholder": "you@example.com",
    "password_placeholder": "********",
    "repeat_password_placeholder": "********",
    "creating_account": "Creating account...",
    "continue_with_email": "Continue with email",
    "continue_with_google": "Continue with Google",
    "or": "Or",
    "already_have_account": "Already have an account?",
    "sign_in": "Sign In",
    "error_password_mismatch": "Passwords do not match",
    "error_verification_failed": "Verification failed. Please try again.",
    "error_google_signup_failed": "Failed to initiate Google sign-up. Please try again.",
    "connecting": "Connecting...",
    "signin_title": "Sign in",
    "forgot_password": "Forgot your password?",
    "dont_have_account": "Don't have an account?",
    "sign_up": "Sign Up",
    "signing_in": "Signing in...",
    "error_google_signin_failed": "Failed to initiate Google sign-in. Please try again.",
    "copy_link": "Copy link",
    "oauth_blocked_title": "Google sign-in blocked",
    "oauth_blocked_description": "Google doesn't allow sign-in from in-app browsers for security reasons. Copy the link below and open it in Safari or Chrome.",
    "oauth_blocked_step1": "Tap \"Copy link\" below",
    "oauth_blocked_step2": "Open Safari or Chrome",
    "oauth_blocked_step3": "Paste the link and sign in",
    "oauth_blocked_email_fallback": "Or sign in with email instead",
    "in_app_browser_notice_prefix": "If you want to use Google sign-in, reopen",
    "in_app_browser_notice_suffix": "in your preferred browser (Chrome / Firefox / Safari) outside of {{browserName}}",
    "copied": "Copied!"
  },
  "connectPopup": {
    "title": "Connect an account",
    "subtitle": "Avoid errors from missing data and get better analysis results",
    "providers": {
      "instagram": {
        "name": "Instagram",
        "description": "Connect your Instagram account."
      },
      "youtube": {
        "name": "YouTube",
        "description": "Connect your YouTube account."
      },
      "tiktok": {
        "name": "TikTok",
        "description": "Connect your TikTok account."
      }
    },
    "active_accounts": "{{count}} active",
    "connect_button": "Secure Connect"
  },
  "chat": {
    "title": "Ask questions about your social media account",
    "placeholder": "Ask a question...",
    "send_instruction": "Enter to send, Shift+Enter for new line",
    "explore_deeper_single": "Explore deeper {{titles}}",
    "explore_deeper_multiple": "Explore deeper these ideas: {{titles}}",
    "quick_actions": {
      "open_last_chat": "Open last conversation",
      "lead_search": "Find sponsorship leads",
      "collab_of_the_week": "Collab of the week",
      "engagement_rate": "What's my engagement rate for last 30 days?",
      "create_video": "Create a video based on my top performing post",
      "most_viewed_post": "Why did my most viewed post do well?",
      "evaluate_profile": "Evaluate my creator profile and content strategy",
      "next_video_type": "What should I post next?",
      "grow_followers": "How can I grow my followers this month?",
      "find_brand_sponsorship_deals": "Find brand sponsorship deals for me",
      "find_sponsorships": "View collab recommendations of the week",
      "create_portfolio": "Create your own creator portfolio website",
      "tutorial": "Give me a tutorial on what you can do",
      "create_content_plan": "Create 10 days content plan",
      "compare_highest_lowest": "Compare my highest and lowest viewed post in last 30 days",
      "optimize_bio": "Optimize my bio"
    }
  },
  "authModal": {
    "close": "Close"
  },
  "portfolioViews": {
    "title": "Portfolio views",
    "last_24_hours": "Last 24 hours",
    "loading": "Loading view stats...",
    "total_views": "Total views",
    "unique_viewers": "Unique viewers",
    "empty": "No views logged yet. Share your portfolio link to start tracking."
  },
  "account_social": {
    "disconnect": "Disconnect",
    "disconnect_aria": "Disconnect account",
    "update_ai": "Update Lema with latest data",
    "update_ai_aria": "Updating Lema",
    "instagram_direct": "Direct Connection",
    "instagram_via_facebook": "Via Facebook",
    "facebook_connected": "Facebook connected",
    "no_instagram_professional": "but no Instagram Professional Account found. Make sure your Facebook page has an Instagram Professional Account linked to it.",
    "change_instagram_account": "Change Instagram Account",
    "view_channel": "View Channel",
    "unlock_analytics": "✨ Refresh advanced analytics model",
    "unlock_analytics_locked": "🔒 Unlock Advanced Analytics",
    "unlock_analytics_aria": "Unlock content prediction and advanced analytics",
    "unlock_analytics_loading": "Running analysis...",
    "unlock_analytics_modal_title": "Unlock Content Prediction & Advanced Analytics",
    "unlock_analytics_modal_description": "Get predicted views and likes for your content idea and detailed breakdown why your content works (e.g. showing face +20% views)",
    "unlock_analytics_modal_cta": "Upgrade to Pro"
  },
  "account_indexing": {
    "instagram": {
      "checking": "Checking your Instagram account...",
      "analyzing": "Analyzing your content strategy...",
      "gathering_insights": "Gathering insights from your posts...",
      "learning_audience": "Learning your audience preferences...",
      "organizing": "Organizing your social media data...",
      "finalizing": "Almost done, finalizing your profile..."
    },
    "tiktok": {
      "checking": "Checking your TikTok account...",
      "analyzing": "Analyzing your content trends...",
      "gathering_insights": "Gathering insights from your videos...",
      "learning_audience": "Learning your audience preferences...",
      "organizing": "Organizing your social media data...",
      "finalizing": "Almost done, finalizing your profile..."
    },
    "youtube": {
      "checking": "Checking your YouTube channel...",
      "analyzing": "Analyzing your content performance...",
      "gathering_insights": "Gathering insights from your videos...",
      "learning_audience": "Learning your audience preferences...",
      "organizing": "Organizing your channel data...",
      "finalizing": "Almost done, finalizing your profile..."
    }
  },
  "agent_thinking": {
    "agent": "Agent",
    "analyzing_user_question": "Analyzing User Question",
    "applying_socmed_best_practices": "Applying Socmed Best Practices",
    "researching_platform": "Researching the Platform",
    "diving_to_data": "Diving to Data",
    "thinking": "Thinking...",
    "planning": "Planning...",
    "understanding": "Understanding...",
    "processing": "Processing...",
    "working": "Working..."
  },
  "agent_tools": {
    "get_schema_and_table": "Get Schema and Table",
    "lead_gen_v9": "Looking For Brands",
    "google_instagram_search": "Searching the Web",
    "google_ig_tt_yt_search": "Searching the Web",
    "create_post": "Creating Post",
    "query_supabase_v2": "Fetching Data",
    "query_database": "Getting Data From Database",
    "scrape_tiktok_profile": "Getting TikTok Profile",
    "scrape_instagram_profile": "Getting Instagram Profile",
    "scrape_youtube_profile": "Getting YouTube Profile",
    "link_captioner": "Understanding the Link",
    "cobalt_link": "Converting Link",
    "fetch_youtube_video_detail": "Getting YouTube Video",
    "fetching_audience": "Fetching Audience Data",
    "fetch_audience": "Fetching Audience Data",
    "deep_statistics_agent": "Analyzing Statistics",
    "searching_web": "Searching the Web",
    "creating_post": "Creating Post",
    "query_caption": "Fetching Creator Writing Style",
    "tool_call": "Tool Call"
  }
};

export default enTranslation;
